import { Http, RequestOptionsArgs } from '@angular/http';
import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { IApplicationState } from '../../stateManagement/states/applicationState';
import { Subscription } from 'rxjs/Rx';
import { ApplicationVersionReceivedAction } from '../../stateManagement/actions/containers/application';

@Injectable()
export class VersionCheckerService {

  private interval = 1000 * 60 * 60; // checking new update every hour
  public url = `${document.location.origin}/version.json`;

  constructor(
    private http: Http,
    private zone: NgZone,
    private store: Store<IApplicationState>
  ) {
    if (!document.location.origin) {
      this.url = document.location.protocol + '//' + document.location.hostname + (document.location.port ? ':' + document.location.port : '');
    } else {
      this.url = document.location.origin;
    }
    this.url += `/version.json`;
  }

  check() {
    let options: RequestOptionsArgs = {};
    options.search = new URLSearchParams();
    options.search.set('timestamp', (new Date()).getTime());
    return this.http.get(this.url, options);
  }

  start() {
    let checkTimer: Subscription;
    this.zone.runOutsideAngular(() => {
      checkTimer = Observable.timer(0, this.interval)
        .switchMap(() => this.check())
        .retry()
        .filter( response => response && response.status === 200)
        .subscribe( (res) => {
          this.store.dispatch(new ApplicationVersionReceivedAction(res.json()));
        });
    });

    return checkTimer;
  }

  updateVersion() {
    if (window) {
      window.location.reload(true);
    }
  }

  checkForVersion() {
    return this.check()
      .retry()
      .filter(response => response && response.status === 200)
      .take(1)
      .subscribe(this.notifyNewVersion.bind(this));
  }

  private notifyNewVersion(response) {
    this.store.dispatch(new ApplicationVersionReceivedAction(response.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/version-checker.service.ts